<!--  -->
<template>
  <div>
    <el-table
      v-loading="loading"
      :data="tableData"
      max-height="500"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="keyword"
        label="关键词"
        width="400"
        align="center"
      >
        <template slot-scope="scope">
          <div class="daertw">{{ scope.row.keyword }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at_str"
        label="时间"
        align="center"
      />
    </el-table>
    <pagination-right
      :current-page="pageIfon.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { keywordCollectrecord } from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      pageIfon: {
        page: 1,
        page_size: 10,
        pid: null
      },
      total: null,
      loading: false,
      tableData: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async send(id) {
      console.log(id)
      this.pageIfon.pid = id
      this.list()
    },
    async list() {
      this.loading = true
      const data = await keywordCollectrecord(this.pageIfon)
      this.total = data.data.total
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.daertw{
    width: 360px;
    margin: 0 auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
